import numeral from 'numeral';

numeral.register('locale', 'de', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return '.';
    },
    currency: {
        symbol: '€'
    }
});

numeral.locale('de');


export class CurrencyFormatValueConverter {

    toView(value, format = '0.00') {
        if (!value) {
            return ''
        }
        return numeral(value).format(format)
    }
}